/**
 * @section : Global JavaScript functions / helpers
 * @project : Fuentes
 * @author  : Iain van der Wiel <iain@e-sites.nl>
 */

'use strict';

/**
 * Generic helper and utility methods
 * Do not use for site-specific logic
 *
 * @type {Object}
 */
var util = {
  isTouchDevice: (function () {
    var msGesture = window.navigator && window.navigator.msMaxTouchPoints && window.MSGesture,
      touch = (( 'ontouchstart' in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch);

    return !!touch;
  }()),

  /**
   * Helper function as alias for getElementById, mainly used to see if a certain DOM element exists
   *
   * @author Boye Oomens <boye@e-sites.nl>
   * @param {String} id - id selector without the hash character
   * @return {Boolean}
   */
  isset: function (id) {
    return !!document.getElementById(id);
  },

  /**
   * Handles external links based on rel="external"
   *
   * @author Boye Oomens <boye@e-sites.nl>
   */
  setExtLinks: function () {
    this.target = '_blank';
  },

  /**
   * Global XHR error handling function, so we can log all our "unknown" XHR errors
   *
   * @param  {Object} e - jQuery event object
   * @param  {Object} xhr - jQuery XHR object
   * @param  {Object} exception
   * @return {Object} error Object
   * @author Joris van Summeren <joris@e-sites.nl>
   */
  processXhrError: function (e, xhr, exception, error) {
    var msg = '',
      url;

    if ( exception && exception.url ) {
      url = exception.url;
    }

    if ( exception === 'timeout' || error === 'timeout' ) {
      msg = 'Timeout error.';
    } else if ( xhr.status === 0 ) {
      msg = 'Can\'t connect. Verify network.';
    } else if ( xhr.status === 403 ) {
      msg = 'Forbidden [403]';
    } else if ( xhr.status === 404 ) {
      msg = 'Not Found [404]';
    } else if ( xhr.status === 500 ) {
      msg = 'Internal Server Error [500].';
    } else if ( exception === 'parsererror' ) {
      msg = 'Requested JSON parse failed.';
    } else if ( exception === 'abort' ) {
      msg = 'Ajax request aborted.';
    } else if ( error.message ) {
      msg = error.message + '.';
    } else {
      msg = 'Uncaught Error. ' + xhr.responseText + ' [' + xhr.status + '].';
    }

    throw new Error('A XHR error occurred: ' + msg + (url ? ' (URL: ' + url + ')' : '') );
  },

  /**
   * Small wrapper around $script to fix conditional loading
   *
   * @param  {Object} setup options
   * @author Boye Oomens <boye@e-sites.nl>
   */
  loadScript: function (setup) {
    if ( typeof $script === 'undefined' ) {
      return console.warn('Could not load module: $script is undefined');
    }
    if ( !setup || !$.isPlainObject(setup) ) {
      return console.warn('Could not load module: no setup given or `setup` is not an object');
    }
    if ( setup.hasOwnProperty('test') && !!setup.test ) {
      $script.order(($.isArray(setup.url) ? setup.url : [setup.url]), setup.callback || $.noop);
    }
  },

  /**
   * Kickstarts form validation based on Parsley.js
   *
   * @author Boye Oomens <boye@e-sites.nl>
   * @param  {String} selector target elements
   * @param  {Object} conf optional config object
   * @see    http://parsleyjs.org/
   */
  initFormValidation: function (selector, conf) {
    var $forms = $(selector);

    // Fail silenty when there are no forms in the DOM
    if ( !$forms.length ) {
      return;
    }

    // Instantiate Parsley plugin (no chaining after this)
    $forms.parsley($.extend({
      focus: 'none'
    }, conf || {}));

    // Apply main listener that display the corresponding error container
    $forms.each(function () {
      $(this).parsley().on('form:validated', util.handleValidationResult);
      // Disable the submit button while form is being processed
      $(this).on('submit', function() {
        const $submitButton = $(this).find('[data-js-bind="submit"]');
        $submitButton.attr('data-status', 'pending');
        $submitButton.prop('disabled', true);
      })
    });
  },

  /**
   * Shows parsley error container and sets focus to make sure that screenreaders
   * will read the corresponding message(s)
   *
   * @author Boye Oomens <boye@e-sites.nl>
   * @author Iain van der Wiel <iain@e-sites.nl>
   * @param  {Object} e Event object
   */
  handleValidationResult: function (e) {
    var $form = $(e.$element[0]).closest('form');

    util.checkTabErrors($form);

    if ( !e.validationResult ) {
      $form
        .scrollTo({
          scrollContainer: ($('.main').length)? '.main': 'html,body'
        })
        .find('.parsley-error-container')
        .attr({
          'tabindex': '0',
          'role': 'error'
        });

      $form.addClass('has-errors');
    } else {
      // Prevent multiple submits by disabling the submit button
      // Small check to see if we're dealing with a legit submit event
      $form.removeClass('has-errors');
      // if ( e.submitEvent ) {
      // 	$form
      // 		.find('[type="submit"]')
      // 		.attr('disabled', 'disabled');
      // }
    }
  },

  /**
   * Focus search box when pressing '/'
   *
   * @author Boye Oomens <boye@e-sites.nl>
   * @param  {Object} e Event object
   */
  focusSearchBox: function (e) {
    if ( e.keyCode === 191 && !/(input|textarea)/.test(e.target.nodeName.toLowerCase()) ) {
      $('form[role="search"]').eq(0).find('input').eq(0).trigger('focus');
    }
  },

  checkTabErrors: function ($el) {
    $($el)
      .find('.tab-link')
      .removeClass('tab-error')
      .end()
      .find('.parsley-error, .parsley-errors-list.filled')
      .closest('.tab-header-and-content')
      .find('.tab-link')
      .addClass('tab-error')
      .first()
      .trigger('click');
  }
};

module.exports = util;
